/**
 * Whether a stored or submitted answer answers its question: text that is not
 * blank, a finite number, a yes or a no, or one of the question's own choices.
 * The public page and the server ask the same thing, so a form the page lets
 * through is never refused for a reason the guest cannot see.
 */
export function rsvpAnswerFilled(question, value) {
    if (!value || typeof value !== 'object')
        return false;
    const v = value;
    switch (question.questionType) {
        case 'TEXT':
            return typeof v.text === 'string' && v.text.trim() !== '';
        case 'NUMBER':
            return typeof v.number === 'number' && Number.isFinite(v.number);
        case 'YES_NO':
            return typeof v.bool === 'boolean';
        case 'SINGLE_CHOICE': {
            if (typeof v.choice !== 'string' || v.choice.trim() === '')
                return false;
            const choices = question.config?.choices;
            return !Array.isArray(choices) || choices.length === 0 || choices.includes(v.choice);
        }
        default:
            return true;
    }
}
/**
 * The required questions left unanswered, given what the guest sent and what
 * is already stored (a later edit need not repeat an answer given before).
 */
export function missingRequiredAnswers(questions, submitted, stored = {}) {
    return questions
        .filter((q) => q.isRequired)
        .filter((q) => {
        const value = q.id in submitted ? submitted[q.id] : stored[q.id];
        return !rsvpAnswerFilled(q, value);
    })
        .map((q) => q.id);
}
//# sourceMappingURL=rsvpQuestions.js.map